import styles from "./Rank.module.scss";
// Utils
import images from "../../../../utils/images";

const rankImages = {
  diamond: images.diamondRank,
  golden: images.goldenRank,
  silver: images.silverRank,
  bronze: images.bronzeRank,
};

const Rank = ({ data }) => {
  return (
    <div className={`${styles.rank} ${styles[data.rank]}`}>
      <img alt={""} src={rankImages[data.rank]} />
      <p>سطح {data.name}</p>
      <p>{data.tax}٪</p>
      <p>{data.period}</p>
    </div>
  );
};

export default Rank;
